import * as React from 'react'
import PropTypes from 'prop-types'

const QrTransferIcon = ({ size = 48, color = '#101820' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.25 4C4.56 4 4 4.56 4 5.25v15c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25v-15c0-.69-.56-1.25-1.25-1.25h-15zm22.5 0c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25v-15C44 4.56 43.44 4 42.75 4h-15zM6.5 6.5H19V19H6.5V6.5zm22.5 0h12.5V19H29V6.5zM9 9v7.5h7.5V9H9zm22.5 0v7.5H39V9h-7.5zM5.25 26.5c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25v-15c0-.69-.56-1.25-1.25-1.25h-15zm22.5 0c-.69 0-1.25.56-1.25 1.25V34H29v-5h5v-2.5h-6.25zm10 0c-.69 0-1.25.56-1.25 1.25V34H39v-5h5v-2.5h-6.25zM6.5 29H19v12.5H6.5V29zM9 31.5V39h7.5v-7.5H9zM31.5 34v2.5h-1.25c-.69 0-1.25.56-1.25 1.25V44h2.5v-5H34v5h2.5v-6.25c0-.69-.56-1.25-1.25-1.25H34V34h-2.5zm10 0v10H44V34h-2.5z"
        fill={color}
      />
    </svg>
  )
}

QrTransferIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
}

export default React.memo(QrTransferIcon)
